import React, { Component } from 'react';
import { Switch } from 'react-router-dom';
import { Paper } from '@material-ui/core';
import { RouteBreadcrumb } from '../layout';
import { VideoList, Viewer } from '.';
import { VideoApi, DeviceApi } from '../../api';
import { get, set } from 'lodash';
import moment from 'moment';
import qs from 'qs';

const Library = class extends Component {
  state = {
    startDate: moment({ hour: 0, minute: 0, second: 0, millisecond: 0 }),
    endDate: moment({ hour: 0, minute: 0, second: 0, millisecond: 0 }),
    sort: { value: '-startTime', label: 'Date (newest)' },
    device: null,
    devices: [],
    video: null,
    videos: null,
    videosNext: null,
    hasMoreItems: true,
    fetching: false,
    fetchError: false
  };

  handleSort = sort => {
    this.setState({ sort: sort });
  };

  handleStartDate = date => {
    this.setState({ startDate: date });
  };

  handleEndDate = date => {
    this.setState({ endDate: date });
  };

  handleDevice = device => {
    this.setState({ device: device });
  };

  searchVideos = () => {
    let params = {
      page: {
        number: 1,
        size: 20
      }
    };
    if (this.state.startDate) {
      set(params, 'filter.startTime.$gte', this.state.startDate.valueOf());
    }
    if (this.state.endDate) {
      set(
        params,
        'filter.startTime.$lt',
        moment(this.state.endDate.valueOf())
          .add(1, 'd')
          .valueOf()
      );
    }
    if (this.state.device) {
      set(params, ['filter', 'device.id'], this.state.device.value);
    }
    if (this.state.sort) {
      set(params, 'sort', this.state.sort.value);
    }
    const query = qs.stringify(params, { encode: false });
    this.setState({ videos: [] });
    this.setState({ fetching: true, fetchError: false });
    return VideoApi.get(null, query).then(
      response => this.handleVideosResponse(response),
      err => {
        if (this.mounted) {
          this.setState({ fetching: false, fetchError: true });
        }
      }
    );
  };

  nextVideos = () => {
    this.setState({ fetching: true, fetchError: false });
    return VideoApi.getPath(this.state.videosNext).then(
      response => this.handleVideosResponse(response),
      err => {
        if (this.mounted) {
          this.setState({ fetching: false, fetchError: true });
        }
      }
    );
  };

  handleVideosResponse = response => {
    if (this.mounted) {
      let newState = { fetching: false };
      newState.videosNext = get(response, 'links.next');
      newState.hasMoreItems =
        response.data.length &&
        get(response, 'links.self') !== get(response, 'links.last');
      if (response.data.length) {
        let videos = this.state.videos;
        response.data.forEach(item => {
          videos.push(item);
        });
        newState.videos = videos;
      }
      this.setState(newState);
    }
  };

  loadDevices = async () => {
    const devices = [];
    const params = {
      page: {
        size: 100
      }
    };
    const query = qs.stringify(params, { encode: false });
    let path = `${DeviceApi.path}/list?${query}`;
    while (path) {
      const response = await DeviceApi.getPath(path);
      const newItems = response.data.map(device => ({
        value: device.id,
        label: device.serialNumber
      }));
      devices.push(...newItems);
      path = response.links.next;
    }
    this.setState({ devices: devices });
  };

  getVideo = id => {
    this.setState({ fetching: true, fetchError: false });
    return VideoApi.get(id).then(
      response => {
        if (this.mounted) {
          this.setState({ video: response.data, fetching: false });
        }
      },
      err => {
        if (this.mounted) {
          this.setState({ fetching: false, fetchError: true });
        }
      }
    );
  };

  componentDidMount = () => {
    this.mounted = true;
  };

  componentWillUnmount = () => {
    this.mounted = false;
  };

  render = () => {
    const {
      startDate,
      endDate,
      devices,
      device,
      sort,
      video,
      videos,
      fetching,
      fetchError,
      hasMoreItems
    } = this.state;
    const { match } = this.props;

    return (
      <Paper>
        {match.isExact && (
          <VideoList
            startDate={startDate}
            endDate={endDate}
            sort={sort}
            devices={devices}
            device={device}
            data={videos}
            fetching={fetching}
            fetchError={fetchError}
            handleStartDate={this.handleStartDate}
            handleEndDate={this.handleEndDate}
            handleSort={this.handleSort}
            handleDevice={this.handleDevice}
            loadDevices={this.loadDevices}
            searchVideos={this.searchVideos}
            nextVideos={this.nextVideos}
            hasMoreItems={hasMoreItems}
          />
        )}
        <Switch>
          <RouteBreadcrumb
            name="name"
            displayName="displayName"
            title="Viewer"
            path={`${match.url}/:id`}
            render={props => (
              <Viewer
                data={video}
                fetching={fetching}
                getVideo={this.getVideo}
                {...props}
              />
            )}
          />
        </Switch>
      </Paper>
    );
  };
};
export default Library;



// WEBPACK FOOTER //
// ./src/components/pages/Library.js